import type { ReactNode } from 'react';
import { theme } from '../theme';
import { Icon, IconName } from '../components/Icon';

/**
 * Editorial-секция в духе музейного каталога: волосяная линия сверху,
 * порядковый номер (01/02) и Fraunces-заголовок, опциональное действие справа.
 */
export function Section({
  n,
  icon,
  title,
  action,
  first,
  children,
}: {
  n?: string;
  icon?: IconName;
  title: string;
  action?: ReactNode;
  first?: boolean;
  children: ReactNode;
}) {
  return (
    <section
      style={{
        marginTop: first ? 0 : 34,
        borderTop: first ? 'none' : `1px solid ${theme.colors.line}`,
        paddingTop: first ? 0 : 20,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 16 }}>
        <h2 style={{ fontSize: 21, display: 'flex', alignItems: 'baseline', gap: 10 }}>
          {n && <span className="num" style={{ fontSize: 12, color: theme.colors.sub }}>{n}</span>}
          {icon && <Icon name={icon} size={16} color={theme.colors.sub} style={{ alignSelf: 'center' }} />}
          {title}
        </h2>
        {action}
      </div>
      {children}
    </section>
  );
}
